exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".readPrivacyPolicyCheckbox__link___3haEW {\n  color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"link": "readPrivacyPolicyCheckbox__link___3haEW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/ReadPrivacyPolicyCheckbox/readPrivacyPolicyCheckbox.scss
// module id = 4530
// module chunks = 6